// The ERP and the register in their own browser windows (acceptance pass, D-5). The register opens in a window named
// "delta-pos" and the ERP lives in "delta-erp": opening either again finds the window by its name and brings it to the
// front instead of opening a duplicate. An open window is told where to go (a message to it, so a register with a
// cart in progress is not reloaded); a new one is loaded at the path. When the browser blocks the new window, the
// path opens in this one.

export const POS_WINDOW = "delta-pos", ERP_WINDOW = "delta-erp";
const MSG = "delta-window-go";

function open(name: string, path: string) {
  let w: Window | null = null;
  try { w = window.open("", name); } catch { w = null; }
  if (!w) { window.location.assign(path); return; }
  let blank = true;
  try { blank = w.location.href === "about:blank"; } catch { blank = true; }
  if (blank) w.location.href = path;
  else w.postMessage({ type: MSG, path }, window.location.origin);
  try { w.focus(); } catch { /* the browser decides */ }
}

export const openPos = (path = "/pos") => open(POS_WINDOW, path);
export const openErp = (path = "/home") => open(ERP_WINDOW, path);

/** Names this window and follows "go to" messages from the other window (same origin only). */
export function claimWindow(name: string, go: (path: string) => void): () => void {
  try { if (window.name !== name) window.name = name; } catch { /* ignore */ }
  const on = (e: MessageEvent) => {
    if (e.origin !== window.location.origin || !e.data || e.data.type !== MSG || typeof e.data.path !== "string" || !e.data.path.startsWith("/")) return;
    go(e.data.path);
  };
  window.addEventListener("message", on);
  return () => window.removeEventListener("message", on);
}

// Two installable apps from one site (acceptance pass, D-8): the ERP manifest (start /home, scope /) and the register
// manifest (start /pos, scope /pos), with their own names, icons and ids. The page links the manifest of the shell it
// shows, so installing from the register installs Delta POS and installing from any ERP screen installs Delta ERP.
// No service worker is registered: nothing is cached for offline use and the register cannot sell offline.
const APPS = {
  erp: { manifest: "/manifest-erp.webmanifest", icon: "/icons/erp-192.png", theme: "#07152D" },
  pos: { manifest: "/manifest-pos.webmanifest", icon: "/icons/pos-192.png", theme: "#0A1526" }
} as const;

function headLink(rel: string): HTMLLinkElement {
  let l = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!l) { l = document.createElement("link"); l.rel = rel; document.head.appendChild(l); }
  return l;
}

export function linkApp(app: keyof typeof APPS) {
  const a = APPS[app];
  const m = headLink("manifest");
  if (m.getAttribute("href") !== a.manifest) m.setAttribute("href", a.manifest);
  headLink("apple-touch-icon").setAttribute("href", a.icon);
  let t = document.head.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!t) { t = document.createElement("meta"); t.name = "theme-color"; document.head.appendChild(t); }
  t.content = a.theme;
}
